import { format } from "date-fns";
import noLocale from "date-fns/locale/nb";

const formatWithLocale = (date: Date) => format(date, "dd.MM.yyyy", { locale: noLocale });

export default formatWithLocale;
